export class LogbogPersonaleRequest {
    constructor(forloebIds: string[]) {
        this.forloebIds = forloebIds;
    }

    forloebIds: string[];
}
